import '../../../../../modules/link-to-element';
import '../../../../../modules/picture';
import {imageConfig} from './__config/images';

export default (ctx, html) => html`
  <main id="home-header">
    <div class="side-container">
      <slot name="left"></slot>
    </div>

    <div id="skip-navigation">
      <slot name="skip-navigation"></slot>
    </div>

    <div id="right" class="side-container">
      <slot name="right"></slot>
    </div>

    <nav id="initial-header">
      <div id="initial-header-imgs">
        <aofl-img id="initial-header-logo" class="${ctx.initialHeaderAnimation}" src="${imageConfig.logoTopMobile[0].src}" height="172" width="556" alt="Logo for Adventure Academy from the Creators of ABCmouse. For Kids age 8 to 13."></aofl-img>
        <aofl-img id="initial-header-ribbon" src="${imageConfig.ribbonMenu[0].src}" height="145" width="1713" alt=""></aofl-img>
      </div>
      <slot></slot>
    </nav>

    <nav id="scrolled-header">
      <aofl-picture id="scrolled-header-img-container">
        <aofl-source media="(max-width: 768px)" srcset="${imageConfig.scrolledHeaderMobile[0].src}" height="109" width="2400"></aofl-source>
        <aofl-img id="scrolled-header-img" src="${imageConfig.scrolledHeader[0].src}" height="218" width="4800" alt=""></aofl-img>
      </aofl-picture>
      <div id="scrolled-header-content">
        <aofl-img id="aa-nav-emblem" src="${imageConfig.emblem[0].src}" height="196" width="168" alt=""></aofl-img>
        <aofl-picture>
          ${imageConfig.menuLogo.map((image) => html`
            <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
          `)}
          <aofl-img id="aa-nav-menu-logo" src="${imageConfig.menuLogo[3].src}" width="453" height="36" alt=""></aofl-img>
        </aofl-picture>
      </div>
    </nav>
  </main>
`;
